import React from "react";
import { NavLink } from "react-router-dom";
import { Home, History, User } from "lucide-react";

const items = [
  { to: "/", label: "Home", Icon: Home, testid: "emp-nav-home" },
  { to: "/my-tasks", label: "History", Icon: History, testid: "emp-nav-history" },
  { to: "/profile", label: "Profile", Icon: User, testid: "emp-nav-profile" },
];

export const EmployeeBottomNav = () => (
  <nav data-testid="employee-bottom-nav"
    className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-slate-200 flex justify-around items-stretch h-20 pb-2 z-50">
    {items.map(({ to, label, Icon, testid }) => (
      <NavLink key={to} to={to} end={to === "/"} data-testid={testid}
        className={({ isActive }) => `flex flex-col items-center justify-center gap-1 w-full transition-colors ${isActive ? "text-indigo-600" : "text-slate-500"}`}>
        {({ isActive }) => (
          <>
            <Icon className="w-6 h-6" strokeWidth={2.5} />
            <span className={`text-[11px] tracking-tight ${isActive ? "font-bold" : "font-medium"}`}>{label}</span>
          </>
        )}
      </NavLink>
    ))}
  </nav>
);
